import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../components/layouts/Layout";
import EmailShare from './components/ShocialShareGraph/Email/EmailShare'
import SmsShare from './components/ShocialShareGraph/Sms/SmsShare'
import PieChartComponent from './components/ShocialShareGraph/TotalPieChart/PieChart'
import AreaComponent from './components/ShocialShareGraph/AreaChart/Area'
import './style/dashboard.css';
import { AllSocialShare, getAllDashboardAnalytics } from "./slice/dashboardAnalyticsAction";
import { LoadingSpinner } from "../../components/Loader/Loader";
import http from "../../config/BaseUrl";
import LocalStorage from "../../hook/LocalStorage";


const Dashboard = ({ children }) => {

  const dispatch = useDispatch();
  const { user } = LocalStorage();
  const { isLoading, dashboard_analytics } = useSelector(state => state.dashboardAnalytics);
  const { isLoadingSocial, socialShare } = useSelector(state => state.dashboardAnalytics);
  const { total_event, live_event, upcoming_event, capture_data } = dashboard_analytics && dashboard_analytics
  const { social_share } = socialShare && socialShare
  const [leadCount, setLeadCount] = useState(0);
  const [leadCountLoading, setLeadCountLoading] = useState(false);

  const getLeadCount = async () => {
    try {
      setLeadCountLoading(true);
      const res = await http.get("leads/lead-counts");
      setLeadCount(res?.data?.lead_count || 0);
    } catch (error) {
      setLeadCount(0);
    } finally {
      setLeadCountLoading(false);
    }
  };


  useEffect(() => {
    dispatch(getAllDashboardAnalytics())
    dispatch(AllSocialShare())
  }, [dispatch]);

  useEffect(() => {
    if (Number(user?.id) === 43) {
      getLeadCount();
    }
  }, [user?.id]);

  
  return (
    <Layout>
      <div className="row">
        <div className="col-12 col-lg-12 col-xl-12">
          <div className="card-deck flex-column flex-lg-row">
            <div className="shadow card radius-15 bg-primary">
              <div className="text-center card-body">
                <div className="mx-auto bg-white widgets-icons rounded-circle">
                  <i className="bx bx-glasses-alt"></i>
                </div>
                <h4 className="mt-3 mb-0 text-white font-weight-bold">{!isLoading ? live_event ? live_event : 0 : <LoadingSpinner color="text-white" />}</h4>
                <p className="mb-0 text-white">Live Events</p>
              </div>
            </div>
            <div className="shadow card radius-15 bg-primary">
              <div className="text-center card-body">
                <div className="mx-auto bg-white widgets-icons rounded-circle">
                  <i className="bx bx-calendar-star"></i>
                </div>
                <h4 className="mt-3 mb-0 text-white font-weight-bold">{!isLoading ? upcoming_event ? upcoming_event : 0 : <LoadingSpinner color="text-white" />}</h4>
                <p className="mb-0 text-white">Upcoming Events</p>
              </div>
            </div>
            <div className="shadow card radius-15 bg-primary">
              <div className="text-center card-body">
                <div className="mx-auto bg-white widgets-icons rounded-circle">
                  <i className="bx bx-camera-movie"></i>
                </div>
                <h4 className="mt-3 mb-0 text-white font-weight-bold">{!isLoading ? capture_data ? capture_data : 0 : <LoadingSpinner color="text-white" />}</h4>
                <p className="mb-0 text-white">Total captured media</p>
              </div>
            </div>
            <div className="shadow card radius-15 bg-primary">
              <div className="text-center card-body">
                <div className="mx-auto bg-white widgets-icons rounded-circle">
                  <i className="bx bx-task"></i>
                </div>
                <h4 className="mt-3 mb-0 text-white font-weight-bold">{!isLoading ? total_event ? total_event : 0 : <LoadingSpinner color="text-white" />}</h4>
                <p className="mb-0 text-white">Total events </p>
              </div>
            </div>
            {Number(user?.id) === 43 && (
              <div className="shadow card radius-15 bg-primary">
                <div className="text-center card-body">
                  <div className="mx-auto bg-white widgets-icons rounded-circle">
                    <i className="bx bx-user-pin"></i>
                  </div>
                  <h4 className="mt-3 mb-0 text-white font-weight-bold">
                    {!leadCountLoading ? leadCount : <LoadingSpinner color="text-white" />}
                  </h4>
                  <p className="mb-0 text-white">Lead Count</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="col-12 col-lg-12 col-xl-12">
          <div className="card radius-15">
            <div className="card-body">
              <div className="mb-4 d-lg-flex align-items-center">
                <div>
                  <h5 className="mb-0">Social Share</h5>
                </div>
                <div className="ml-auto">
                  <h5 className="mb-0">
                    <span className="ml-2 d-flex align-items-center" >Total Share:
                      {!isLoadingSocial ? (social_share ? social_share.total_share : 0) : (<LoadingSpinner className="spinner-grow-sm" />)}
                    </span>
                  </h5>
                </div>
              </div>
              <hr />

              <div className="dashboard-social-list social-share-list">
                <div className="row">
                  <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                    <div className="text-center d-flex flex-column align-items-center justify-content-center">
                      <div className="mb-1 text-white widgets-social bg-primary social-share-item">
                        <i className="bx bx-envelope"></i>
                      </div>
                      <div className="media-body">
                        <h4 className="">{!isLoadingSocial ? (social_share ? social_share.email : 0) : (<LoadingSpinner className="spinner-grow-sm" />)}</h4>
                        <p className="pt-0 text-secondary font-weight-bold">Email</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                    <div className="text-center d-flex flex-column align-items-center justify-content-center">
                      <div className="mb-1 text-white widgets-social bg-primary social-share-item">
                        <i className="bx bx-message-detail"></i>
                      </div>
                      <div className="media-body">
                        <h4 className="">{!isLoadingSocial ? (social_share ? social_share.sms : 0) : (<LoadingSpinner className="spinner-grow-sm" />)}</h4>
                        <p className="pt-0 text-secondary font-weight-bold">SMS</p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                    <div className="text-center d-flex flex-column align-items-center justify-content-center">
                      <div className="mb-1 text-white widgets-social bg-primary social-share-item">
                        <i className="lni lni-facebook"></i>
                      </div>
                      <div className="media-body">
                        <h4 className="">{!isLoadingSocial ? (social_share ? social_share.facebook : 0) : (<LoadingSpinner className="spinner-grow-sm" />)}</h4>
                        <p className="pt-0 text-secondary font-weight-bold">Facebook</p>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                    <div className="text-center d-flex flex-column align-items-center justify-content-center">
                      <div className="mb-1 text-white widgets-social bg-primary social-share-item">
                        <i className="lni lni-twitter"></i>
                      </div>
                      <div className="media-body">
                        <h4 className="">{!isLoadingSocial ? (social_share ? social_share.twitter : 0) : (<LoadingSpinner className="spinner-grow-sm" />)}</h4>
                        <p className="pt-0 text-secondary font-weight-bold">Twitter</p>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                    <div className="text-center d-flex flex-column align-items-center justify-content-center">
                      <div className="mb-1 text-white widgets-social bg-primary social-share-item">
                        <i className="lni lni-instagram"></i>
                      </div>
                      <div className="media-body">
                        <h4 className="">{!isLoadingSocial ? (social_share ? social_share.instagram : 0) : (<LoadingSpinner className="spinner-grow-sm" />)}</h4>
                        <p className="pt-0 text-secondary font-weight-bold">Instagram</p>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                    <div className="text-center d-flex flex-column align-items-center justify-content-center">
                      <div className="mb-1 text-white widgets-social bg-primary social-share-item">
                        <i className="lni lni-linkedin"></i>
                      </div>
                      <div className="media-body">
                        <h4 className="">{!isLoadingSocial ? (social_share ? social_share.linkedin ? social_share.linkedin : 0 : 0) : (<LoadingSpinner className="spinner-grow-sm" />)}</h4>
                        <p className="pt-0 text-secondary font-weight-bold">Linkedin</p>
                      </div>
                    </div>
                  </div> */}

                </div>

              </div>

            </div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-lg-4 col-xl-4">
          <div className="card radius-15">
            <div className="card-body">
              <EmailShare />
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 col-lg-4 col-xl-4">
          <div className="card radius-15">
            <div className="card-body">
              <SmsShare />
            </div>
          </div>
        </div>
        {/* <div className="col-12 col-md-4 col-lg-4 col-xl-4">
          <div className="card radius-15">
            <div className="card-body">
              <FacebookShare />
            </div>
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-lg-4 col-xl-4">
          <div className="card radius-15">
            <div className="card-body">
              <TwitterShare />
            </div>
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-lg-4 col-xl-4">
          <div className="card radius-15">
            <div className="card-body">
              <LinkedInShare />
            </div>
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-lg-4 col-xl-4">
          <div className="card radius-15">
            <div className="card-body">
              <InstagramShare />
            </div>
          </div>
        </div> */}

      </div>

      <div className="row">
        <div className="col-12 col-lg-6 col-xl-6">
          <div className="card radius-15">
            <div className="card-body">
              <AreaComponent />
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-xl-6">
          <div className="card radius-15">
            <div className="card-body">
              <PieChartComponent />
            </div>
          </div>
        </div>
      </div>



      {/* <div className="my-5 row">
                <div className="col-md-6">
                        <div className="text-center">
                            <h3>Latest Session</h3>
                            <p>Loading...</p>
                        </div>
                   <div className="my-3 d-flex justify-content-center align-items-center">
                        
                        <img src="https://via.placeholder.com/500x300" className="shadow img-fluid image__style" alt="" />
                   </div>
                </div>
                <div className="col-md-6">
                        <div className="text-center">
                            <h3>Calendar</h3>
                            <p>All your events will be added to the calendar</p>
                        </div>
                    <div className="my-3 d-flex justify-content-center align-items-center">
                        <CalendarComponent />
                    </div>
                </div>
            </div> */}
    </Layout>
  );
};

export default Dashboard;
